<template>
  <div>
    <v-container>
      <v-form ref="updateUser">
        <v-container>
          <v-row>
            <v-col>
              <v-text-field
                v-model="updatedUser.email"
                :rules="[rules.email]"
                label="E-mail"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <hr />
        <v-btn color="blue darken-1" style="float: right;" text @click="save()">
          değişiklikleri kaydet
        </v-btn>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import * as userReq from "../../request/user.js";
export default {
  props: ["user", "popUpStatus"],
  data() {
    return {
      rules: {
        required: (value) => !!value || "Gerekli.",
        counter: (value) => value.length >= 5 || "En az 5 karakter",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Geçersiz Email";
        },
      },
      updatedUser: { ...this.user },
    };
  },
  computed: {
  },
  created() {},
  watch: {
    popUpStatus() {
      this.updatedUser = { ...this.user }
    },
  },
  methods: {
    save() {
      if (this.$refs.updateUser.validate()) {
        userReq.updateUserProp(this.updatedUser.id, 'email', this.updatedUser.email, this.updatedUser.tUserCompanies[0].companyId).then(() => {
            this.$store.state.snackbarErrorObj = {
              snackbar: true,
              color: "success",
              text: 'Kaydedildi',
              timeout: 1500,
            };
            this.$emit('refresh')
        }).catch(err => { console.log(err)})
      }
      
    },
  },
};
</script>

<style scoped></style>
